import styled from 'styled-components';
// import * as antd from 'antd';


export const Upload = styled.input.attrs(props => ({
  type: 'file',
  multiple: 'multiple'
}))``;

export const UploadButton = styled.div``;



export const UploadButtonText = styled.div`
  color: #666;
`;

export const UploadImg = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 700px;
`;

export const Item = styled.div`
  border-radius: 4px;
  width: 128px;
  height: 128px;
  margin-bottom: 20px;
  &:not(:last-child) {
    margin-right: 30px;
  }
`;

export const ImgItem = styled(Item)`
  border: 1px solid #d9d9d9;
  padding: 8px;
`;

export const AddItem = styled(Item)`
  border: 1px dashed #d9d9d9;
`;

export const ImgHandle = styled.div`
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
  white-space: nowrap;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all 0.3s;
`;

export const DeleteImg = styled.img.attrs(props => ({
  src: require('../img/delete.png')
}))`
  width: 60px;
  height: 60px;
`;

export const ImgWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  &:hover {
    &::before {
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.7);
      opacity: 1;
      transition: all 0.3s;
      content: ' ';
    }
    ${ImgHandle} {
      opacity: 1;
    }
  }
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  display: block;
`;

export const AddImg = styled.div.attrs(props => ({
  className: 'add-img'
}))`
  &.add-img {
    display: table;
    width: 100%;
    height: 100%;
    text-align: center;
    background-color: #fafafa;
    cursor: pointer;
    transition: border-color 0.3s ease;

    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    font-feature-settings: 'tnum';
    outline: 0;

    display: flex;
    flex-direction: column;
    justify-content: center;

    &:hover {
      border-color: #1890ff;
    }
    ${Upload} {
      display: none;
    }
  }
`;
